import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { Helmet } from 'react-helmet';
import qs from 'qs';

import { getFormValues, change } from 'redux-form';

import Progress from 'components/common/Progress';
import Layout from 'components/common/Layout';
import ClaimsFilter from 'components/reports/ClaimsFilter';
import ClaimsTable from 'components/reports/ClaimsTable';
import TabNavigation from 'components/common/TabNavigation';

import { fetchClaims, clearClaims, loadClaimEra } from 'redux/modules/claims';
import { fetchBusiness } from 'redux/modules/business';
import { addRouterParamsPageSettings } from 'redux/modules/routerParams';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = () => ({
  toolbar: {
    marginBottom: 16,
  },
});

class Claims extends Component {
  constructor(props) {
    super(props);

    this.onRequest = this.onRequest.bind(this);
    this.onSortingChange = this.onSortingChange.bind(this);
    this.onTableScroll = this.onTableScroll.bind(this);
    this.onMobileFilterBottonClick = this.onMobileFilterBottonClick.bind(this);
    this.onToolbarResize = this.onToolbarResize.bind(this);

    this.state = {
      mobileFilterExpanded: ['xs', 'sm'].indexOf(props.width) === -1,
      toolbarExpanded: false,
      toolbarHeight: 0,
      limit: 10,
      offset: 0,
    };

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    this.props.actions.clearClaims();
  }

  componentDidMount() {
    const { location, actions } = this.props;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (params.ID) {
      actions.change('claimsFilter', 'Filters', null);
      actions.change('claimsFilter', 'Patient Name / Patient ID', null);
      actions.change('claimsFilter', 'Date of Creation From', null);
      actions.change('claimsFilter', 'Date of Creation To', null);
      actions.change('claimsFilter', 'Date of Service From', null);
      actions.change('claimsFilter', 'Date of Service To', null);
      actions.change('claimsFilter', 'Claim ID', params.ID);
    }
    if (params['check-number']) {
      actions.change('claimsFilter', 'Filters', null);
      actions.change('claimsFilter', 'Patient Name / Patient ID', null);
      actions.change('claimsFilter', 'Date of Creation From', null);
      actions.change('claimsFilter', 'Date of Creation To', null);
      actions.change('claimsFilter', 'Date of Service From', null);
      actions.change('claimsFilter', 'Date of Service To', null);
      actions.change('claimsFilter', 'Claim ID', null);
      actions.change('claimsFilter', 'Filters.Check Number', [{
        value: Number(params['check-number']),
        label: params['check-number'],
      }]);
    }
    this.onRequest();
    actions.fetchBusiness({
      triggerLoading: true,
    });
    // actions.loadClaimEra({
    //   values: {
    //     'Load Date': '04/06/2026',
    //   },
    // });
  }

  componentWillReceiveProps(nextProps) {
    const { filters, width } = this.props;
    const { limit, offset } = this.state;
    const nextOrderStatusID = nextProps.filters['Order Status ID']
      ? nextProps.filters['Order Status ID'].join('')
      : null;
    const currentOrderStatusID = filters['Order Status ID']
      ? filters['Order Status ID'].join('')
      : null;
    const nextInsuranceInfoID = nextProps.filters['Insurance Info ID']
      ? nextProps.filters['Insurance Info ID'].join('')
      : null;
    const currentInsuranceInfoID = filters['Insurance Info ID']
      ? filters['Insurance Info ID'].join('')
      : null;
    const nextAssignedUserID = nextProps.filters['Assigned User ID']
      ? nextProps.filters['Assigned User ID'].join('')
      : null;
    const currentAssignedUserID = filters['Assigned User ID']
      ? filters['Assigned User ID'].join('')
      : null;
    const nextClaimStatus = nextProps.filters['Claim Status']
      ? nextProps.filters['Claim Status'].join('')
      : null;
    const currentClaimStatus = filters['Claim Status']
      ? filters['Claim Status'].join('')
      : null;
    const nextCheckNumber = nextProps.filters['Check Number']
      ? nextProps.filters['Check Number'].join('')
      : null;
    const currentCheckNumber = filters['Check Number']
      ? filters['Check Number'].join('')
      : null;
    const filtersChanged =
      nextOrderStatusID !== currentOrderStatusID
      || nextInsuranceInfoID !== currentInsuranceInfoID
      || nextAssignedUserID !== currentAssignedUserID
      || nextClaimStatus !== currentClaimStatus
      || nextCheckNumber !== currentCheckNumber
      || nextProps.filters['Date of Creation From'] !== filters['Date of Creation From']
      || nextProps.filters['Date of Creation To'] !== filters['Date of Creation To']
      || nextProps.filters['Date of Service From'] !== filters['Date of Service From']
      || nextProps.filters['Date of Service To'] !== filters['Date of Service To']
      || nextProps.filters['Claim Md Code'] !== filters['Claim Md Code'];
    let newOffset = offset;
    if (filtersChanged) {
      newOffset = 0;
    }
    if (nextProps.loading <= 0 && nextProps.count > 0 && nextProps.count <= offset) {
      newOffset = offset - limit;
    }

    if (newOffset !== offset) {
      this.setState({ offset: newOffset });
    }

    if (nextProps.width !== width) {
      this.setState({
        mobileFilterExpanded: ['xs', 'sm'].indexOf(nextProps.width) === -1,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, sortBy, sort, claims, count, loading } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Patient Name / Patient ID', 'Claim Md Code'],
        immediateFilterKeys: [
          'Claim ID',
          'Date of Creation From',
          'Date of Creation To',
          'Date of Service From',
          'Date of Service To',
        ],
        arrayFilterKeys: [
          'Order Status ID',
          'Insurance Info ID',
          'Assigned User ID',
          'Claim Status',
          'Check Number',
        ],
      },
    );
    const sortByChanged = prevProps.sortBy !== sortBy;
    const sortChanged = prevProps.sort !== sort;
    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged || sortByChanged || sortChanged) {
      this.onRequest();
    } else if (claims.length < count
      && this.scrollRef
      && this.scrollRef.scrollTop === 0
      && loading === 0) {
      this.onTableScroll({ target: this.scrollRef });
    }
  }

  onRequest() {
    const { actions, filters, sortBy, sort, variant } = this.props;
    const { limit, offset } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name = key;
        let operation = 'startswith';
        let caseSensitivity = null;
        const val = filters[key];
        switch (key) {
          case 'Patient Name / Patient ID':
            if (/^\d+$/.test(filters[key])) {
              name = 'Patient Record Number';
              operation = 'eq';
            } else {
              name = 'Patient Full Name';
              caseSensitivity = false;
              operation = 'contains';
            }
            break;
          case 'Order Status ID':
            name = 'Order Line Workflow Status ID';
            operation = 'in';
            break;
          case 'Insurance Info ID':
          case 'Claim Status':
            operation = 'in';
            break;
          case 'Date of Creation From':
            name = 'Date of Creation';
            operation = 'ge';
            break;
          case 'Date of Service From':
            name = 'Date of Service';
            operation = 'ge';
            break;
          case 'Date of Creation To':
            name = 'Date of Creation';
            operation = 'le';
            break;
          case 'Date of Service To':
            name = 'Date of Service';
            operation = 'le';
            break;
          case 'Claim ID':
            name = 'ID';
            operation = 'eq';
            break;
          case 'Assigned User ID':
            name = 'Claim Assigned User ID';
            operation = 'in';
            break;
          case 'Claim Md Code':
            name = 'ID';
            // caseSensitivity = false;
            operation = 'eq';
            break;
          case 'Check Number':
            name = 'Check Book Number';
            operation = 'in';
            break;
          default:
            caseSensitivity = false;
        }
        return {
          name,
          operation,
          val,
          ...caseSensitivity !== null ? { case_sensitivity: caseSensitivity } : {},
        };
      })
      : null;
    actions.fetchClaims({
      limit,
      offset,
      ...requestFilters ? {
        filters: requestFilters,
      } : {},
      ...sortBy ? {
        sortBy: [{
          name: sortBy,
          sort,
        }],
      } : {},
      variant,
      triggerLoading: true,
      push: offset > 0,
    });
  }

  onTableScroll(event) {
    const { offset, limit } = this.state;

    if ((event.target.offsetHeight + event.target.scrollTop) / event.target.scrollHeight > 0.9) {
      if ((this.props.claims.length - limit) >= offset) {
        this.setState({
          offset: offset + limit,
        });
      }
    }
  }

  onSortingChange(newSortBy) {
    const { actions, location, sort, sortBy } = this.props;
    let newSort;
    if (sortBy !== newSortBy) {
      newSort = 'asc';
    } else {
      newSort = sort === 'asc' ? 'desc' : 'asc';
    }
    actions.addRouterParamsPageSettings({
      [location.pathname]: {
        sortBy: newSortBy,
        sort: newSort,
      },
    });
  }

  onMobileFilterBottonClick() {
    this.setState({ mobileFilterExpanded: !this.state.mobileFilterExpanded });
  }

  onToolbarResize({ expandedView, expansionDetailsHeight }) {
    this.setState({
      toolbarExpanded: expandedView,
      toolbarHeight: expansionDetailsHeight,
    });
  }

  render() {
    const {
      count,
      loading,
      sortBy,
      sort,
      claims,
      contextFiltersOptions,
      filters,
      history,
      location,
      classes,
      business,
      variant,
      width,
    } = this.props;
    const { mobileFilterExpanded, toolbarExpanded, toolbarHeight } = this.state;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    let tableHeightAdjustment = toolbarExpanded ? toolbarHeight + 208 : 208;
    if (width === 'xs' || width === 'sm') {
      tableHeightAdjustment = mobileFilterExpanded ? 276 : 142;
      if (mobileFilterExpanded && toolbarExpanded) {
        tableHeightAdjustment += toolbarHeight;
      }
    }
    return (
      <Layout>
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Claim Reports
          </title>
        </Helmet>
        {/* <TabNavigation
          items={[
            {
              text: 'Claim MD',
              href: '/claims/claim-md',
            },
            {
              text: 'Change',
              href: '/claims/change',
            },
          ]}
        /> */}
        <ClaimsFilter
          form="claimsFilter"
          filters={filters}
          contextFiltersOptions={contextFiltersOptions}
          initializeWithSearchView={filters['Patient Name / Patient ID'] !== null}
          onResetButtonClick={() => {
            if (params.ID || params['check-number']) {
              history.replace(location.pathname);
            }
          }}
          variant={variant}
          mobileFilterExpanded={mobileFilterExpanded}
          width={width}
          onMobileFilterBottonClick={this.onMobileFilterBottonClick}
          onExpansionChange={this.onToolbarResize}
          count={count}
          loading={loading}
          items={claims}
        />
        {loading > 0 &&
          <Progress fixed />
        }
        <ClaimsTable
          style={{
            height: `calc(100dvh - ${tableHeightAdjustment}px)`,
          }}
          items={claims}
          count={count}
          sort={sort}
          sortBy={sortBy}
          onSortingChange={this.onSortingChange}
          loading={loading}
          business={business}
          mobileFilterExpanded={mobileFilterExpanded}
          onScroll={this.onTableScroll}
          scrollRef={(scrollRef) => { this.scrollRef = scrollRef; }}
        />
      </Layout>
    );
  }
}

Claims.propTypes = {
  claims: PropTypes.arrayOf(PropTypes.shape({
    'First Name': PropTypes.string,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    'Order Status ID': PropTypes.arrayOf(PropTypes.number),
    'Insurance Info ID': PropTypes.arrayOf(PropTypes.number),
    'Claim ID': PropTypes.number,
    'Assigned User ID': PropTypes.arrayOf(PropTypes.number),
    'Claim Status': PropTypes.arrayOf(PropTypes.string),
    'Check Number': PropTypes.arrayOf(PropTypes.number),
    'Date of Creation From': PropTypes.string,
    'Date of Creation To': PropTypes.string,
    'Date of Service From': PropTypes.string,
    'Date of Service To': PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    fetchClaims: PropTypes.func.isRequired,
    clearClaims: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  contextFiltersOptions: PropTypes.shape({
    orderStatuses: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
  }),
  business: PropTypes.shape({
    ID: PropTypes.number,
  }).isRequired,
  width: PropTypes.string.isRequired,
};

Claims.defaultProps = {
  sortBy: 'Create At',
  sort: 'desc',
  contextFiltersOptions: {},
  business: {},
};

const mapStateToProps = (store, ownProps) => {
  const claimsFilterValues = getFormValues('claimsFilter')(store);
  const params = qs.parse(ownProps.location.search, { ignoreQueryPrefix: true });
  return {
    claims: store.claims.data,
    count: store.claims.count,
    ...store.routerParams.pageSettings[ownProps.location.pathname],
    business: store.business.data,
    filters: {
      ...claimsFilterValues
        && claimsFilterValues.Filters
        && claimsFilterValues.Filters['Order Status']
        && claimsFilterValues.Filters['Order Status'].length > 0
        ? { 'Order Status ID': claimsFilterValues.Filters['Order Status'].map(item => item.value) }
        : {},
      ...claimsFilterValues
        && claimsFilterValues.Filters
        && claimsFilterValues.Filters.Payer
        && claimsFilterValues.Filters.Payer.length > 0
        ? { 'Insurance Info ID': claimsFilterValues.Filters.Payer.map(item => item.value) }
        : {},
      ...claimsFilterValues
        && claimsFilterValues.Filters
        && claimsFilterValues.Filters.User
        && claimsFilterValues.Filters.User.length > 0
        ? { 'Assigned User ID': claimsFilterValues.Filters.User.map(item => item.value) }
        : {},
      ...claimsFilterValues
        && claimsFilterValues.Filters
        && claimsFilterValues.Filters['Claim Status']
        && claimsFilterValues.Filters['Claim Status'].length > 0
        ? { 'Claim Status': claimsFilterValues.Filters['Claim Status'].map(item => item.value) }
        : {},
      ...claimsFilterValues
        && claimsFilterValues.Filters
        && claimsFilterValues.Filters['Check Number']
        && claimsFilterValues.Filters['Check Number'].length > 0
        ? { 'Check Number': claimsFilterValues.Filters['Check Number'].map(item => item.value) }
        : {},
      ...claimsFilterValues
        && claimsFilterValues.Filters
        && claimsFilterValues.Filters['Date of Creation']
        && claimsFilterValues.Filters['Date of Creation'].length > 0
        ? {
          'Date of Creation From': claimsFilterValues.Filters['Date of Creation'][0].value.split('-')[0],
          'Date of Creation To': claimsFilterValues.Filters['Date of Creation'][0].value.split('-')[1],
        }
        : {},
      ...claimsFilterValues
        && claimsFilterValues.Filters
        && claimsFilterValues.Filters['Date of Service']
        && claimsFilterValues.Filters['Date of Service'].length > 0
        ? {
          'Date of Service From': claimsFilterValues.Filters['Date of Service'][0].value.split('-')[0],
          'Date of Service To': claimsFilterValues.Filters['Date of Service'][0].value.split('-')[1],
        }
        : {},
      ...claimsFilterValues
        && claimsFilterValues['Patient Name / Patient ID']
        ? { 'Patient Name / Patient ID': claimsFilterValues['Patient Name / Patient ID'] }
        : {},
      ...claimsFilterValues
        && claimsFilterValues['Claim Md Code'] && ownProps.variant === 'claim-md'
        ? { 'Claim Md Code': claimsFilterValues['Claim Md Code'] }
        : {},
    },
    ...params.ID ? {
      filters: {
        'Claim ID': Number(params.ID),
      },
    } : {},
    ...params['check-number'] ? {
      filters: {
        'Check Number': [Number(params['check-number'])],
      },
    } : {},
    loading: store.claims.loading + store.business.loading,
    contextFiltersOptions: store.claims.contextFiltersOptions,
    variant: ownProps.variant,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchClaims,
    clearClaims,
    change,
    fetchBusiness,
    addRouterParamsPageSettings,
    loadClaimEra,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withWidth()(Claims))
);



// WEBPACK FOOTER //
// ./src/pages/claims/Claims.js